export const EditorTools = {
  TextNavbarButtonDropdown: {
    tag: 'div',
    Icon: null,
    ignoreChildProps: true,
    ignoreChildExtends: true,
    isActive: null,
    margin: '- U - -',
    '!isActive': {
      ':hover': null,
      ':active': null
    },
    Button: {
      round: 'radiusPill',
      padding: 'Y Y1',
      ariaHaspopup: 'true',
      title: (el) => el.call('polyglot', 'editor.tools.editOptions'),
      icon: (el) => {
        const preffered = (el.getCanvasScope?.() || el.scope || {}).preferredEditor
        const map = {
          editor: 'sf pencil',
          code: 'code',
          sidebar: 'sidebarLeft'
        }
        return map[preffered] || map['editor']
      },
      // Icon's box comes from width/height (boxSize), never fontSize — left
      // unset this rode the same ambient font-size cascade as every other
      // EditorTools button. Pin it to match the row explicitly.
      Icon: { boxSize: 'A A' },
      text: null,
      lineHeight: 0.9,
      align: 'end',
      onClick: (ev, el) => {
        ev.stopPropagation()
        el.call('openDropdown', {
          id: 'editInNavbar',
          anchorEl: el,
          placement: 'bottom-end',
          content: { extends: 'EditInNavbarMenu' }
        })
      },
      // Brand DropdownArrow (extends Icon) only sets `fontSize: 'Y1'` — same
      // footgun: Icon ignores fontSize for sizing. And boxSize rides the
      // SPACING scale, where 'Y1' is ~4px — the chevron rendered as a speck
      // (2026-08-08 per Nika "icons sizes"). Z1 (~one step under the 12px
      // row icon) reads as the accessory glyph it is while staying visible.
      DropdownArrow: {
        margin: '- - - Y',
        boxSize: 'Z1 Z1'
      }
    },
    // @symbo.ls/dropdown (2026-06-09, task #2) — the IconButton opens the
    // EditInNavbarMenu body via the shared DropdownRoot, replacing the legacy
    // DropdownParentFocus (which stayed visible when inactive). The plugin owns
    // open/close + outside-click/ESC dismiss.
    IconButton: null
  },
  ShareBtn: {
    hide: true,
    icon: 'share outline',
    title: (el) => el.call('polyglot', 'common.action.share'),
    isActive: (el) => el.getWindow('componentEditor') === 'share',
    onClick: (ev, el) => {
      if (el.getWindow('componentEditor') === 'share') {
        el.closeWindow('componentEditor')
      } else {
        el.setWindow('componentEditor', 'share')
      }
      el.parent.update()
    }
  },
  extends: 'NavbarButtonSet',
  gap: 'W',
  childProps: {
    '.isDisabled': {
      opacity: '.35',
      pointerEvents: 'none'
    }
  }
}
